import React, { useState } from 'react';
import { observer } from 'mobx-react';
import SelectTab from '../share/SelectTab';
import Total from './total/total';
import Items from './items/items';

const RakutenHotelTab = {
  ITEMS: '全件',
  TOTAL: '総数'
} as const;
export type RakutenHotelTabType = keyof typeof RakutenHotelTab;

const RakutenHotel = observer(() => {
  const [rakutenHotelTab, setRakutenHotelTab] = useState<RakutenHotelTabType>(
    (utils.getParam('rakuten_hotel_tab') as RakutenHotelTabType) || 'ITEMS'
  );

  return (
    <>
      <SelectTab tabs={RakutenHotelTab} currentTab={rakutenHotelTab} onChange={setRakutenHotelTab} />
      {rakutenHotelTab === 'ITEMS' ? <Items /> : <Total />}
    </>
  );
});

export default RakutenHotel;
